module.exports = __webpack_public_path__ + "f246d098b26d6a65ca77a8d5975439ed.png";